// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableFavoritePlace_Component__35l52"};